import React from 'react';

export const Logo = ({ className }) => (
  <img src="https://i.ibb.co/52fjJNh/icon128.png" alt="Smart Memo Logo" className={className} />
);